import type { ReactNode } from "react"

import { Breadcrumbs } from "@/components/breadcrumbs"
import { SidebarTrigger } from "@/components/ui/sidebar"
import type { BreadcrumbItem as BreadcrumbItemType } from "@/types"

export function AppSidebarHeader({
  breadcrumbs = [],
  search,
  actions,
  hideBreadcrumbsOnMobile = false,
}: {
  breadcrumbs?: BreadcrumbItemType[]
  search?: ReactNode
  actions?: ReactNode
  hideBreadcrumbsOnMobile?: boolean
}) {
  return (
    <header className="border-sidebar-border/50 flex h-16 shrink-0 items-center gap-2 border-b px-6 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 md:px-4">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <SidebarTrigger className="-ml-1" />
        <div
          className={hideBreadcrumbsOnMobile ? "hidden md:block" : undefined}
        >
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {search}
        {actions}
      </div>
    </header>
  )
}
